import { matchPathname } from './routes';

/**
 * Returns resource locator parameters for the current search route.
 *
 * @param {Array} routes Current route configuration
 * @param {Object} location Current React Router location
 * @returns {{routeName: string, pathParams: Object}}
 */
export const getSearchPageResourceLocatorStringParams = (routes, location) => {
  const matchedRoutes = matchPathname(location.pathname, routes);
  const searchPageRoute = 'SearchPage';
  const searchPageListingTypeRoute = 'SearchPageWithListingType';

  if (matchedRoutes.length > 0) {
    const matched = matchedRoutes[0];
    const { params: pathParams, route } = matched;
    const routeName =
      route.name === searchPageListingTypeRoute ? searchPageListingTypeRoute : searchPageRoute;

    return {
      routeName,
      pathParams,
    };
  }

  console.error(`Route not found for pathname ${location.pathname}, redirecting to SearchPage`);
  return {
    routeName: searchPageRoute,
    pathParams: {},
  };
};
